import { PropsOf } from '../../types';
import AudioUploader from './AudioUploader';
import connect from './connect';

export default connect(AudioUploader);
export type AudioUploaderProps = PropsOf<ReturnType<typeof connect>>;
